import { Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

export const NavigateText = ({
  name,
  id,
  resource,
}: {
  name: string;
  id: string;
  resource: string;
}) => {
  const navigate = useNavigate();
  return (
    <Text
      color="text.brandLight"
      fontWeight="700"
      fontSize="0.75rem"
      lineHeight="1rem"
      cursor={'pointer'}
      whiteSpace="normal"
      wordBreak="break-word"
      overflow="visible"
      textOverflow="unset"
      _hover={{
        color: 'text.primary',
        textDecoration: 'underline',
        cursor: 'pointer',
      }}
      onClick={() => {
        let path = '';
        switch (resource) {
          case 'practice':
            path = `/practices/${id}`;
            break;
          case 'market':
            path = `/markets/${id}`;
            break;
          case 'provider':
          default:
            path = `/providers/${id}`;
            break;
        }
        navigate(path);
      }}
    >
      {name || 'N.A.'}
    </Text>
  );
};
